import {Hidden, HiddenProps} from './Hidden'

export default Hidden
export type {HiddenProps}
